import { DateTime } from 'luxon';
import { CoreItem, CoreItemBackend } from '../core-item/core-item';
import { GoalBackend } from '../goal/goal';
import { MethodologyBackend } from '../methodology/methodology';
import { ProductBackend } from '../product/product';
import { ResumeBackend } from '../resume/resume';
import { SessionTemplateBackend } from '../session-template/session-template';
import { UserClerkPublicMetadata } from '../user/user-clerk';
import { SalesCycle } from '../workspace/workspace';

export const SESSION_LENGTH = 63; // 60 mins + 3 mins buffer

export const INIT_CREDITS = 20;
export const FREE_TRIAL_MINS = 13;

export const FREE_TRIAL_INTERVAL_HOURS = 24;

export enum SessionCredits {
  normal = 10,
  code = 15,
}

export function isCreditsEnoughForSessionType(sessionType: SessionType, credits: number) {
  return true;
  if (sessionType === SessionType.normal) {
    return credits >= SessionCredits.normal;
  } else if (sessionType === SessionType.code) {
    return credits >= SessionCredits.code;
  } else {
    throw new Error('Unknown session type');
  }
}

export function canFreeTrial(userPublicMetadata: UserClerkPublicMetadata) {
  const oldFreeTrialDate = userPublicMetadata.freeTrialDateStr
    ? DateTime.fromISO(userPublicMetadata.freeTrialDateStr as string)
    : undefined;

  if (!oldFreeTrialDate) {
    return true;
  }

  if (oldFreeTrialDate && -oldFreeTrialDate.diffNow('hours').hours > FREE_TRIAL_INTERVAL_HOURS) {
    return true;
  }

  return false;
}

export interface SessionBackend extends CoreItemBackend {
  type: SessionType;
  status: SessionStatus;
  subData: SessionSubData;
}

export enum SessionStatus {
  notStarted = 'notStarted',
  ongoing = 'ongoing',
  done = 'done',
}

export enum SessionType {
  normal = 'normal',
  code = 'code',
}

export interface Session extends CoreItem {
  subData: SessionSubData;
}

export interface SessionMethodologyEvaluation {
  overallScore: number;
  overallReason: string;
  overallImprovements: string;
  evaluations: {
    criterion: string;
    rating: number;
    reason: string;
    improvements: string;
  }[];
}

export interface SessionSubData {
  template?: Partial<SessionTemplateBackend>;
  personalityList?: { id: string; title: string; description: string }[];
  product?: ProductBackend;
  salesCycle?: SalesCycle;
  goal?: Partial<GoalBackend>;
  methodology?: MethodologyBackend;
  resume?: ResumeBackend;

  summary?: string;
  goalEvaluation?: string;
  objectionHandlingEvaluation?: string;

  methodologyEvaluation?: SessionMethodologyEvaluation;
  score?: number;

  isFamiliarProduct?: boolean;

  additionalPrompt?: string;
  additionalRubrics?: string[];

  language: string;

  performance: SessionPerformance;
  creativity: SessionCreativity;

  recordingUrl?: string;

  deepgramKey?: string;
  deepgramKeyExpiredAtStr?: string;
}

export enum SessionPerformance {
  Speed = 'Speed',
  Quality = 'Quality',
}

export enum SessionCreativity {
  Deterministic = 'Deterministic',
  Creative = 'Creative',
}

export enum SessionAnswerMode {
  Concise = 'Concise',
  Detailed = 'Detailed',
}
